import React from 'react';
import './JoinSessionButton.css';

type JoinSessionButtonProps = {
  onClick?: () => void;
};

const JoinSessionButton: React.FC<JoinSessionButtonProps> = ({ onClick }) => (
  <button className="join-session-btn" onClick={onClick}>
    Join Session
  </button>
);

export default JoinSessionButton; 